import { render, staticRenderFns } from "./UpdateMaxActivitiesLimitPopup.vue?vue&type=template&id=59c6f2da&scoped=true&"
import script from "./UpdateMaxActivitiesLimitPopup.vue?vue&type=script&lang=ts&"
export * from "./UpdateMaxActivitiesLimitPopup.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateMaxActivitiesLimitPopup.vue?vue&type=style&index=0&id=59c6f2da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c6f2da",
  null
  
)

export default component.exports